export var GrabReceiptType;
(function (GrabReceiptType) {
    GrabReceiptType["Food"] = "FOOD";
    GrabReceiptType["Ride"] = "RIDE";
})(GrabReceiptType || (GrabReceiptType = {}));
//# sourceMappingURL=grab-receipt-type.enum.js.map